import { combineReducers } from 'redux';
import enrollment from './enrollment.reducer';
import courseEnrollment from './courseEnrollment.reducer';

const enrollmentAppReducer = combineReducers({
    enrollment,
    courseEnrollment
});

export default enrollmentAppReducer;


// WEBPACK FOOTER //
// src/main/content/enrollment/store/reducers/index.js